import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  Goal,
  GoalItem,
  GoalItemType,
  goalItemTypes,
} from '@/models/goal.model';
import { NEW_ID } from '@/util/constants';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalItems',
  props: {
  items: {
    type: Array as PropType<GoalItem[]>,
    required: true,
  },
  goal: {
    type: Object as PropType<Goal>,
    required: true,
  },
},
  emits: ['update'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<GoalItem[]>(
  [...props.items].sort((a, b) => a.column - b.column),
);

// list items
// add item (choose new, or fill out listHeader)

function addItem() {
  items.value = [
    ...items.value,
    {
      id: NEW_ID - items.value.length,
      column: items.value.length,
      type: GoalItemType.header,
      listHeader: '',
    },
  ];

  emit('update', items.value);
}

function update() {
  emit('update', items.value);
}

watch(
  () => props.items,
  () => {
    items.value = [...props.items].sort((a, b) => a.column - b.column);
  },
);

function moveUp(item: GoalItem) {
  const index = items.value.findIndex((a) => a.id === item.id);

  items.value = [
    ...items.value.slice(0, index - 1),
    item,
    items.value[index - 1],
    ...items.value.slice(index + 1),
  ].map((v, index) => ({ ...v, column: index }));

  update();
}

function moveDown(item: GoalItem) {
  const index = items.value.findIndex((a) => a.id === item.id);

  items.value = [
    ...items.value.slice(0, index),
    items.value[index + 1],
    item,
    ...items.value.slice(index + 2),
  ].map((v, index) => ({ ...v, column: index }));

  update();
}

function remove(item: GoalItem) {
  items.value = items.value
    .filter((a) => a.id !== item.id)
    .map((v, index) => ({ ...v, column: index }));

  update();
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_row, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "1",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(index + 1) + ".", 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: item.type,
                      "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                      label: "Type",
                      density: "compact",
                      items: _unref(goalItemTypes),
                      "hide-details": true
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                  ]),
                  _: 2
                }, 1024),
                (item.type === _unref(GoalItemType).header)
                  ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: item.listHeader,
                          "onUpdate:modelValue": ($event: any) => ((item.listHeader) = $event),
                          label: "Header",
                          density: "compact",
                          "list-props": { maxWidth: '250px' },
                          "hide-details": true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "1",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: ($event: any) => (moveUp(item)),
                      icon: "mdi-arrow-up",
                      class: "remove-button",
                      size: "tiny",
                      disabled: index === 0
                    }, null, 8, ["onClick", "disabled"]),
                    _createVNode(_component_v_btn, {
                      onClick: ($event: any) => (remove(item)),
                      icon: "mdi-delete-outline",
                      class: "remove-button",
                      size: "tiny"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      onClick: ($event: any) => (moveDown(item)),
                      icon: "mdi-arrow-down",
                      class: "remove-button",
                      size: "tiny",
                      disabled: index === items.value.length - 1
                    }, null, 8, ["onClick", "disabled"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            type: "button",
            onClick: addItem,
            color: "info",
            flat: ""
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Add item")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})